require("./bxslider-4-master/src/js/jquery.bxslider.js");
require("./bxslider-4-master/src/css/jquery.bxslider.css");